/**
 * Scroll to anchor
 */

import animateScrollTo from 'animated-scroll-to';

class ScrollToAnchor {

    delayScroll = null;

    constructor() {

        let self = this;

        // is there a hash in the URL, e.g. #my-anchor ?
        document.addEventListener("DOMContentLoaded", (event) => {
            if (window.location.hash) {
                self.scrollToElm(500);
            }
        });

        // on hash changes without a page (re)load
        window.onhashchange = function() {
            self.scrollToElm(0); // no need to wait, page already loaded
        }
    }

    scrollToElm(delay) {

        // stop any pending animations
        clearTimeout(self.delayScroll);

        // get the element ID to scroll to from the hash
        let elmId = window.location.hash.substring(1);

        // is there a (closed) reveal button for the new hash?
        let revealBtnClosed = document.querySelector('[data-scroll-to-button="true"][aria-expanded="false"]#'+elmId);

        if (revealBtnClosed) {
            // yes - click the button to open the panel
            // => reveal.js will take care of scrolling to the top of the button
            self.delayScroll = setTimeout(() => {
                revealBtnClosed.click();
            }, delay);
        } else {
            // no - animate scroll to reveal button, if it exists
            let elm =  document.querySelector('[data-scroll-to-button="true"]#'+elmId);
            if (elm) {
                // scroll to the element
                let verticalOffset = -62;
                if (window.innerWidth < 768) {
                    verticalOffset = -62; // remove navbar
                }
                // Scroll after a short delay while the page is fully rendered
                self.delayScroll = setTimeout(() => {
                    animateScrollTo(elm, {
                        verticalOffset: verticalOffset,
                    });
                }, delay);
            }
        }
    }
}
export default ScrollToAnchor;